<div class="badge-item" [ngClass]="cssClass">
  <div class="badge-container">
    <div class="badge-item-header">
      <span class="badge-title">{{ item.userData?.fullName }}</span>
      <span class="badge-subtitle">{{ item?.userData?.department }}</span>
    </div>
    <div class="badge-item-footer">
      <div class="flex-row">
        <div class="flex-1 footer-part">
          <span>{{ "users.item.role." + item?.userRole | translate }}</span>
          <label>{{ "users.item.roleTitle" | translate }}</label>
        </div>

        <div class="flex-1 footer-part">
          <span>{{ item.id }}</span>
          <label>{{ "users.item.gid" | translate }}</label>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-1 footer-part">
          <span>{{ item.userData.eMail }}</span>
          <label>{{ "users.item.email" | translate }}</label>
        </div>
      </div>
      <!--			<div class="flex-row">
							<div class="flex-1 footer-part" [ngClass]="{'footer-part&#45;&#45;status': !item.certificateExpiration}">
								<ng-container *ngIf="item.certificateExpiration">
									<span>{{item.certificateExpiration | date: 'd MMM y h:mm'}} ({{leftDays}} d)</span>
									<label>{{'users.item.certificateExpiration' | translate}}</label>
								</ng-container>
								<span *ngIf="!item.certificateExpiration">{{'users.item.certificateNotExistent' | translate}}</span>
							</div>
						</div>-->
    </div>
  </div>
</div>
